import * as React from "react";
import InfiniteScroller from "@vingle/wtf-sdk/components/infiniteScroller";
import PulseLoadingDot from "common/components/pulseLoadingDot";
import EmptyContent from "common/components/emptyContent";
import Item from "./item";

const styles = require("./privilegeInterests.scss");

interface IProps {
  privilegeInterests: Vingle.IPaginatedList<Vingle.IPrivilegeInterest>;
  onLoadMorePrivilegeInterests: VoidFunction;
  isLoading: boolean;
  descriptionMessage: string;
  emptyMessage: string;
}

function PrivilegeInterests(props: IProps) {
  const {
    privilegeInterests,
    isLoading,
    onLoadMorePrivilegeInterests,
    descriptionMessage,
    emptyMessage,
  } = props;
  return (
    <>
      <p className={styles.description}>{descriptionMessage}</p>
      <InfiniteScroller
        itemLength={privilegeInterests.data.length}
        loadMore={onLoadMorePrivilegeInterests}
        isLoading={isLoading}
        paging={privilegeInterests.paging}
        loader={
          <div className={styles.loader}>
            <PulseLoadingDot />
          </div>
        }
      >
        {privilegeInterests.data.length ? (
          <div className={styles.container}>
            {privilegeInterests.data.map(interest => (
              <Item privilegeInterest={interest} key={interest.name} />
            ))}
          </div>
        ) : (
          <div className={styles.emptyContent}>
            <EmptyContent message={emptyMessage} />
          </div>
        )}
      </InfiniteScroller>
    </>
  );
}

export default React.memo(PrivilegeInterests);
